import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Utils } from 'ecrion-components';
import FieldMappings from './FieldMappings';
import { withStyles, Grid, FormLabel, FormControl, Tooltip, Button, CircularProgress, Typography } from '@material-ui/core';
var duplicateColumns = [{
  value: 'Email',
  label: 'Email'
}];
var fieldRules = [{
  value: 'AlwaysPreserve',
  label: 'Always Preserve'
}, {
  value: 'AlwaysOverwrite',
  label: 'Always Overwrite'
}, {
  value: 'OverwriteIfEmpty',
  label: 'Overwrite if empty'
}, {
  value: 'Concatenate',
  label: 'Concatenate'
}];

var PeopleMergeRules = function PeopleMergeRules(props) {
  React.useEffect(function () {
    document.title = 'Settings • Merging Rules • Ecrion';
  }, []);

  var _useState = useState({
    value: null,
    loading: true,
    error: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = useState({
    value: [],
    loading: true,
    error: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      leadFields = _useState4[0],
      setLeadFields = _useState4[1];

  var _useState5 = useState({
    submitted: false,
    succeeded: false,
    message: ''
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      submitState = _useState6[0],
      setSubmitState = _useState6[1];

  var goBack = function goBack() {
    props.history.return('/settings');
  };

  useEffect(function () {
    Utils.request({
      url: '/backend/environmentsettings',
      method: 'GET'
    }).then(function (response) {
      if (!response[0].FormsSettings) return;
      var settings = response[0].FormsSettings;
      if (!settings) return;
      setState({
        value: settings,
        loading: false,
        error: null
      });
    }).catch(function (err) {
      setState({
        value: null,
        loading: false,
        error: Utils.getPrettyError(err)
      });
    });
  }, []);
  useEffect(function () {
    Utils.request({
      url: '/backend/criterias?flag=1',
      method: 'GET'
    }).then(function (response) {
      if (!response) return;
      setLeadFields({
        value: response.Groups,
        loading: false,
        error: null
      });
    }).catch(function (err) {
      setLeadFields({
        value: null,
        loading: false,
        error: Utils.getPrettyError(err)
      });
    });
  }, []);

  var validateForm = function validateForm(value) {
    var errors = {};
    if (!value) return;

    if (value.Rules) {
      if (value.Rules.UniqueIdentifier == null) errors['Rules.UniqueIdentifier'] = 'Unique Identifier is required';
      if (value.Rules.DefaultFieldRule == null) errors['Rules.DefaultFieldRule'] = 'Default field rule is required';

      if (value.Rules.Field && value.Rules.Field.Pair) {
        value.Rules.Field.Pair.forEach(function (fieldPair) {
          if (!fieldPair) errors['Rules.Field.Pair'] = 'Field Required';
          if (fieldPair.Source == null || fieldPair.Source.Name == null) errors['Rules.Field.Pair.Source'] = 'Rule field source is required';
          if (fieldPair.Destination == null || fieldPair.Destination.Name == null) errors['Rules.Field.Pair.Destination'] = 'Rule field type is required';
        });
      }
    }

    return errors;
  };

  var saveRules = function saveRules() {
    return Utils.request({
      url: '/backend/environmentsettings/formsconfiguration',
      data: state.value,
      method: 'PUT'
    }).then(function (response) {
      setSubmitState({
        submitted: true,
        succeeded: true,
        message: 'Saved'
      });
      setTimeout(function () {
        setSubmitState({
          submitted: false,
          succeeded: false,
          message: ''
        });
      }, 3000);
    }).catch(function (error) {
      setSubmitState({
        submitted: true,
        succeeded: false,
        message: error
      });
    });
  };

  var getMappingOptions = function getMappingOptions() {
    var sources = leadFields.value.map(function (group) {
      return {
        label: group.Name,
        options: group.Fields.map(function (groupField) {
          return {
            label: groupField.Caption,
            value: groupField.Name
          };
        })
      };
    });
    var destinations = fieldRules.map(function (field) {
      return {
        label: field.label,
        value: field.value
      };
    });
    return {
      sources: sources,
      destinations: destinations
    };
  };

  var renderFieldMappings = function renderFieldMappings(mappingOptions) {
    return React.createElement(Form.FieldArray, {
      name: 'Rules.Field.Pair',
      id: 'Rules-Fields',
      subscription: {}
    }, function (_ref) {
      var fields = _ref.fields;
      return React.createElement(React.Fragment, null, fields.map(function (name, index) {
        return React.createElement(FieldMappings, {
          key: name,
          name: name,
          index: index,
          mappingOptions: mappingOptions,
          onRemove: fields.remove
        });
      }), React.createElement(Tooltip, {
        title: "Add mapping",
        placement: "right"
      }, React.createElement(Typography, null, React.createElement(Button, {
        onClick: function onClick() {
          return fields.push('');
        },
        style: {
          marginTop: '16px'
        }
      }, fields.length !== 0 ? '+' : 'Add Mapping'))));
    });
  };

  var CriteriasRequestError = function CriteriasRequestError() {
    return React.createElement(Typography, null, leadFields.error);
  };

  var renderContent = function renderContent() {
    return React.createElement(Grid, {
      container: true,
      direction: "row"
    }, React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6
    }, React.createElement(React.Fragment, null, React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6
    }, React.createElement(Grid, {
      container: true,
      alignItems: "center",
      justify: "flex-start"
    }, React.createElement(Grid, {
      item: true,
      xs: 2,
      spacing: 1
    }, React.createElement(Form.Fields.Checkbox, {
      name: "Rules.Enabled",
      label: null,
      justity: "flex-start"
    })), React.createElement(Grid, {
      item: true,
      xs: 10
    }, React.createElement(FormLabel, {
      htmlFor: "Rules.Enabled",
      style: {
        fontSize: '14px',
        fontWeight: 'bold'
      }
    }, "Merge leads created by forms")))), React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6
    }, React.createElement(Grid, {
      container: true,
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 4
    }, React.createElement(FormLabel, {
      htmlFor: "Rules.UniqueIdentifier",
      style: {
        fontSize: '14px',
        fontWeight: 'bold'
      }
    }, "Deduplicate using")), React.createElement(Grid, {
      item: true,
      xs: 8
    }, React.createElement(Form.Fields.MultiSelect, {
      required: true,
      name: "Rules.UniqueIdentifier",
      id: "deduplicate-column",
      label: null,
      variant: "filled",
      multi: false,
      options: duplicateColumns,
      menuPlacement: "auto"
    })))), React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6
    }, React.createElement(Grid, {
      container: true,
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 4
    }, React.createElement(FormLabel, {
      htmlFor: "Rules.DefaultFieldRule",
      style: {
        fontSize: '14px',
        fontWeight: 'bold'
      }
    }, "Default field rule")), React.createElement(Grid, {
      item: true,
      xs: 8
    }, React.createElement(Form.Fields.MultiSelect, {
      required: true,
      name: "Rules.DefaultFieldRule",
      id: "merge-field-rule",
      label: null,
      variant: "filled",
      multi: false,
      options: fieldRules,
      menuPlacement: "auto"
    })))), React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6
    }, React.createElement(FieldTitle, null)), React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6
    }, leadFields.loading && React.createElement(Loading, null), leadFields.error && React.createElement(CriteriasRequestError, null), !leadFields.loading && !leadFields.error && renderFieldMappings(getMappingOptions())))));
  };

  return React.createElement(React.Fragment, null, state.loading && React.createElement(Loading, null), state.value && React.createElement(Form.Fragment, {
    key: "LeadMergeRulles",
    renderContent: renderContent,
    submitAlign: "left",
    variant: "filled",
    submitLabel: "Save",
    submittingLabel: "Saving...",
    defaultValue: {
      Rules: {
        Enabled: state.value.Rules.Enabled,
        UniqueIdentifier: state.value.Rules.UniqueIdentifier,
        DefaultFieldRule: state.value.Rules.DefaultFieldRule.Type,
        Field: state.value.Rules.FieldRules ? {
          Pair: state.value.Rules.FieldRules.map(function (fieldRule) {
            return {
              Source: {
                Name: fieldRule.Name
              },
              Destination: {
                Name: fieldRule.Rule.Type
              }
            };
          })
        } : {
          Pair: []
        }
      }
    },
    onValidate: validateForm,
    onSuccess: function onSuccess(data) {
      if (data) {
        var copy = state.value;
        copy.Rules.Enabled = data.Rules.Enabled;
        copy.Rules.UniqueIdentifier = data.Rules.UniqueIdentifier;
        copy.Rules.DefaultFieldRule.Type = data.Rules.DefaultFieldRule;
        copy.Rules.FieldRules = data.Rules.Field.Pair.map(function (fieldPair) {
          return {
            Name: fieldPair.Source.Name,
            Rule: {
              Type: fieldPair.Destination.Name
            }
          };
        });
        setState({
          value: copy,
          loading: false,
          error: null
        });
        return saveRules();
      }
    }
  }), submitState.submitted && (submitState.succeeded ? React.createElement(Typography, {
    className: props.classes.submitOkLabel
  }, submitState.message) : React.createElement(Typography, {
    className: props.classes.submitErrorLabel
  }, Utils.getPrettyError(submitState.message))));
}; //export default LeadsMergeRules;


var styles = {
  loadingIndicator: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '-25px',
    marginTop: '-25px'
  },
  submitOkLabel: {
    color: 'green'
  },
  submitErrorLabel: {
    color: 'red'
  }
};

var FieldTitle = function FieldTitle() {
  return React.createElement(FormControl, {
    margin: "normal",
    style: {
      marginTop: 8 * 3
    }
  }, React.createElement(FormLabel, {
    htmlFor: "",
    style: {
      fontSize: '14px',
      fontWeight: 'bold'
    }
  }, "Rules"));
};

var Loading = function Loading() {
  return React.createElement(CircularProgress, {
    size: 60,
    variant: "indeterminate",
    disableShrink: true,
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginLeft: '-25px',
      marginTop: '-25px'
    }
  });
};

export default withStyles(styles, {
  withTheme: true,
  name: 'ECPeopleMergeRules'
})(PeopleMergeRules);